import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate } from "react-router-dom";

import { TechnicalAnalysisPage } from './pages/TechnicalAnalysisPage';
import { AlertModal } from './components/alerts/AlertModal'; // Ensure correct path to your AlertModal component

import { TechnicalAnalysisDashboard } from './pages/TechnicalAnalysisDashboard';


import 'bootstrap/dist/css/bootstrap.min.css';

import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Features from './components/Features';
import Pricing from './components/Pricing';
import SignUpForm from './components/SignUpForm';
import Footer from './components/Footer';
import StockTickerCarousel from './components/StockTickerCarousel';
import LoginModal from './components/LoginModal';
import SMSBalanceCard from './components/SMSBalanceCard';
import AlartSetFormFixedPrice from './components/AlartSetFormFixedPrice';
import OTPForm from './components/OTPForm';
import PersonalAnalysis from './components/PersonalAnalysis';
import EmailUpdateForm from './components/EmailUpdateForm';

// Helper component to bind URL route parameters to AlertModal
const AlertModalRouteWrapper = () => {
  const { symbol } = useParams();
  const navigate = useNavigate();

  return (
    <AlertModal
      open={true}
      onClose={() => navigate(-1)} // Navigates back on close
      symbol={symbol || "AAPL"}
    />
  );
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [loginVisible, setLoginVisible] = useState(false);
  const [username, setUsername] = useState(localStorage.getItem("username") || "");

  const handleLoginSuccess = (usernameFromLogin) => {
    setIsLoggedIn(true);
    setUsername(usernameFromLogin);
    setLoginVisible(false);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUsername("");
    localStorage.removeItem("token");
    localStorage.removeItem("username");
  };

  return (
    <Router>
      <Header
        onLoginClick={() => setLoginVisible(true)}
        isLoggedIn={isLoggedIn}
        username={username}
        onLogout={handleLogout}
      />

      <main>
        <Routes>
          {/* Home Route */}
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <section id="features"><Features /></section>
                {isLoggedIn ? (
                  <section id="smsbalancecard"><SMSBalanceCard /></section>
                ) : (
                  <section id="signup"></section>
                )}
              </>
            }
          />

          <Route path="/technical-analysis/:symbol?" element={<TechnicalAnalysisPage />} />

          {/* Alert Modal Routes */}
          <Route path="/alerts/:symbol" element={<AlertModalRouteWrapper />} />
          <Route path="/alerts" element={<AlertModalRouteWrapper />} />

          {/* Analysis Route */}
          <Route
            path="/analysis"
            element={<section id="personalanalysis"><PersonalAnalysis /></section>}
          />

          <Route
            path="/AlartSetFormFixedPrice"
            element={<section id="AlartSetFormFixedPrice"><AlartSetFormFixedPrice /></section>}
          />

          <Route
            path="/RegistrationForm"
            element={<section id="OTPForm"><OTPForm /></section>}
          />

          {/* technical analysis and alerm set */}

        <Route path="/technical-analysis-dashboard" element={<TechnicalAnalysisDashboard />} />



          {/* Profile / Update Email Route */}
          <Route
            path="/updateemail"
            element={
              isLoggedIn ? (
                <section id="email-update" className="container py-4">
                  <EmailUpdateForm />
                </section>
              ) : (
                <div style={{ textAlign: "center", marginTop: "50px" }}>
                  <h3>🔒 Please log in to update your profile.</h3>
                  <button
                    className="btn btn-primary mt-3"
                    onClick={() => setLoginVisible(true)}
                  >
                    Log In
                  </button>
                </div>
              )
            }
          />
        </Routes>



        <LoginModal
          visible={loginVisible}
          onClose={() => setLoginVisible(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      </main>

      <Footer />
    </Router>
  );
}

export default App;